import { render, staticRenderFns } from "./QuestionCloseButton.vue?vue&type=template&id=224db1e5&scoped=true&"
import script from "./QuestionCloseButton.vue?vue&type=script&lang=js&"
export * from "./QuestionCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./question-close-button.scss?vue&type=style&index=0&id=224db1e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224db1e5",
  null
  
)

export default component.exports